import { render, staticRenderFns } from "./couponRecord.vue?vue&type=template&id=65b5e45a&scoped=true"
import script from "./couponRecord.vue?vue&type=script&lang=js"
export * from "./couponRecord.vue?vue&type=script&lang=js"
import style0 from "./couponRecord.vue?vue&type=style&index=0&id=65b5e45a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b5e45a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65b5e45a')) {
      api.createRecord('65b5e45a', component.options)
    } else {
      api.reload('65b5e45a', component.options)
    }
    module.hot.accept("./couponRecord.vue?vue&type=template&id=65b5e45a&scoped=true", function () {
      api.rerender('65b5e45a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/userManagement/components/couponRecord.vue"
export default component.exports